module.exports = __webpack_public_path__ + "static/5-8d5079b6be55f9691765c5396ea94ef8.png";